import React, {useState} from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import { useNavigate } from "react-router-dom";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    const [user, setUser] = useState(null); // Store user info after login
    //const navigate = useNavigate();
      // Handle logout logic
      

      // Logout function
    const handleLogout = () => {
        setIsAuthenticated(false);
        setUser(null);
        //navigate("/");
    };
    

    // Toggle navbar collapse
    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };
    return (
        <>
        <div className="top-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-12">
                            <div className="logo">
                                <a href="index.html">
                                    
                                    <img src="img/logo2.png" alt="Logo"/>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7 d-none d-lg-block">
                            <div className="row">
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-calendar"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Opening Hour</h3>
                                            <p>Mon - Fri, 8:00 - 9:00</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-call"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Call Us</h3>
                                            <p>+012 345 6789</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-send-mail"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Email Us</h3>
                                            <p>info@example.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrapper">
        <nav className="navbar navbar-expand-lg navbar-dark">
            <div className="container">
           {/* <a href="/" className="nav-item nav-link "><img src="img/logo2.png" alt="Logo" className="logo"  /></a> */}
                
                
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
                onClick={toggleNavbar}>
                    
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarCollapse">
                    <div className="navbar-nav">
                        <a className="nav-item nav-link" href="/">Home</a>
                        <a className="nav-item nav-link" href="/about">About</a>
                        <a className="nav-item nav-link" href="/service">Service</a>
                       
                       
                        <a className="nav-item nav-link" href="/jobs">Jobs</a>
                        <a className="nav-item nav-link" href="/workers">Workers</a>
                        <a className="nav-item nav-link" href="/workers-profile">Workers Profie</a>
                        
                        <a className="nav-item nav-link" href="/contact">Contact</a>
                    </div>
                    <div className="navbar-nav ms-auto">
                        {!isAuthenticated ? (
                            // Login button when user is not authenticated
                            
                            <a className="nav-item nav-link" href="/signin">Login</a>
                        ) : (
                            // User profile icon & logout dropdown when logged in
                            <div className="user-menu">
                                <div className="user-icon" style={{ cursor: "pointer", position: "relative" }}>
                                    👤 {user.name} {/* Show user name */}
                                    <div className="dropdown">
                                        <button onClick={handleLogout} className="logout-btn btn btn-danger">
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </nav>
        </div>
        </> 
    );
}

export default Navbar;
